export const SiteVariantType = {
    MAIN: 'MAIN', // LegeaAplicata.ro / chat.legeaaplicata.ro
} as const;

export type SiteVariantType = typeof SiteVariantType[keyof typeof SiteVariantType];

export interface SiteVariantConfig {
    name: string;
    domain: string;
    presentationTitle: string;
    features: {
        show_education: boolean;
        show_audio: boolean;
        show_tools: boolean;
        show_legislation: boolean;
        show_news: boolean;
    };
    theme: {
        primary: string;
        secondary: string;
        gradient: string;
    };
}

export const SITE_VARIANTS: Record<SiteVariantType, SiteVariantConfig> = {
    [SiteVariantType.MAIN]: {
        name: "LegeaAplicată",
        domain: "legeaaplicata.ro",
        presentationTitle: "LegeaAplicată",
        features: {
            show_education: true,
            show_audio: true,
            show_tools: true,
            show_legislation: true,
            show_news: true,
        },
        theme: {
            primary: "brand-primary",
            secondary: "brand-gold",
            gradient: "from-slate-900 to-slate-800",
        }
    }
};

export const getSiteVariant = (): SiteVariantType => {
    return SiteVariantType.MAIN;
};

export const getCurrentVariantConfig = (): SiteVariantConfig => {
    const variant = getSiteVariant();
    return SITE_VARIANTS[variant];
};
